<template>
  <div class="is-marginless is-paddingless section section-produit" v-if="produit">
    <div class="entete">
      <div class="columns mgb-0">
        <div class="column pdb-0">
          <h1 class="title is-size-3-">
            {{ getTitle }}
            <b-tag v-if="!produit.actif && productId"
              type="has-background-subMenu"
              class="has-text-white mgl-5px">
              {{$t('catalogue.etatProduit')}}
            </b-tag>
            <b-tag v-if="produit.produitEcranNumerique.materielId && materiel"
              type="has-background-subMenu"
              class="has-text-white mgl-5px">
              {{ getEtatEcran(materiel.etat) }}
            </b-tag>
          </h1>
        </div>
        <div class="column is-narrow pdb-0">
          <div class="is-pulled-right buttons boutonAction">
            <button @click="$router.go(-1)"
              class="button btn-modal-annuler is-cancel">
              {{ $t('general.button.cancel') }}
            </button>
            <button class="button is-addOrEdit"
              @click="saveProduct()">
              {{ $t('general.button.sauvegarder') }}
            </button>
            <piece-jointe-button
              class="mgr-2"
              :perm="constantes.CATALOGUE.maj">
            </piece-jointe-button>
            <button class="button section-details "
              :disabled ="!materiel">
              <b-dropdown position="is-bottom-left" v-if="materiel">
                <div slot="trigger">
                  <b-icon icon="call-split" type="is-default"></b-icon>
                  <b-icon icon="chevron-down" class="has-text-secondary-icon"></b-icon>
                </div>
                <p class="has-text-icon-more is-size-7 mgl-20px mgt-10px">
                  {{$t('catalogue.newProduct.emplacement')}}
                </p>
                <b-dropdown-item has-link class="pdl-20px">
                  <router-link-blank
                    :to="{ name: 'm.gabed.emplacement-materielEdition',
                    params: {
                            id:materiel.dispositif.emplacementId,
                            idMateriel: materiel.id,
                          }
                        }"
                    :message="$t('catalogue.newProduct.seeEmplacement')"
                    classMessage="has-text-default is-size-6"
                    classComposant="noTextDecoration"
                  />
                </b-dropdown-item>
              </b-dropdown>
              <div v-else>
                <b-icon icon="call-split" type="is-default"></b-icon>
                <b-icon icon="chevron-down" class="has-text-secondary-icon"></b-icon>
              </div>
            </button>
          </div>
        </div>
      </div>
      <app-breadcrumb :breadcrumb="breadcrumb" />
        <error-msg-component :messages="messages"
                             :error="error"
                             :messagesChampsVide="messagesChampsVide"
                             :champsVide="champsVide"
                             :title="'editionClient.problemOccurred'"
                             :withEmplyFields="true"
                             @close="error = $event"/>
      <div class="tab">
        <ul>
          <li
            v-for="(tab, index) in tabs"
            :key="index"
            :class="{'is-active': activeTab === tab.component}"
            @click="activeTab = tab.component">
            {{ $t(tab.libelle) }}
          </li>
        </ul>
      </div>
    </div>
    <div class="corps">
      <keep-alive>
        <component
          :is="activeComponent.component"
          :detail="activeComponent.detail"
          :showMsgRegroupementProduit="activeComponent.detail"
          :breadcrumb="breadcrumb"
          :produit="produit"
          :produitValue="produit.produitEcranNumerique"
          :materiel="materiel"
          :permissions="constantes.CATALOGUE"
          popUpName="dispoEcranNumerique"
          :isCard="true"
          :entiteCommerciale="produit.entiteCommerciale"
          :isDisabled="false"
        />
      </keep-alive>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import AppBreadcrumb from '@/components/general/breadcrumb';
import inProgress from '@/services/general/inProgress';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import Produit from '@/components/catalogue/produitGeneral/m_produit';
import Caracteristiques from '@/components/catalogue/produitNumerique/m_caracteristiques';
import ProduitsAssocies from '@/components/catalogue/produitGeneral/l_produitsAssocies';
import genererProduitNumerique from '@/services/catalogue/genererProduitNumerique';
import {
  get,
  create,
  createAvecSynchronisation,
  update,
} from '@/api/produit/produitNumerique';
import messageErreur from '@/services/general/messageErreur';
import messageSucces from '@/services/general/messageSucces';
import { formatProduitAfterGet, formatProduitBeforeSave } from '@/services/catalogue/formatProduit';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import validationGeneral from '@/services/validation/validation';
import validationProduit from '@/services/catalogue/validation/validationProduit';
import translate from '@/services/catalogue/validation/champsProduitTranslator';
import DisponibiliteParJour from '@/components/planning/c_disponibiliteParJour';
import Enseignes from '@/components/entiteCommerciale/m_enseignes';
import Audience from '@/components/entiteCommerciale/m_audience';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import reglesAchat from '@/components/catalogue/produitGeneralPresse/edition/reglesAchat';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import { get as getMaterielPatrimonial } from '@/api/gabed/materiel';
import genererLiaisonTarifFromProduitAssocieLoc from '@/services/catalogue/genererLiaisonTarifFromProduitAssocieLoc';
import { ETAT_DISPOSITIF_PUBLICITAIRE } from '@/configuration/gabed/dispositif/dispositifPublicitaire';
import traductionLibelleEtat from '@/services/devisCommandes/traductionLibelleEtat';
import pieceJointeButton from '@/components/general/button/pieceJointeButton';
import { CATALOGUE } from '@/configuration/permissionsBodacConf';
import demandeInterventionType from '@/components/catalogue/produitGeneral/demandeInterventionType/demandeInterventionType';

const Attachments = createNamespacedHelpers('attachments');
const ProduitStore = createNamespacedHelpers('produit');
const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');

export default {
  data() {
    return {
      activeTab: 'produit',
      produit: null,
      error: false,
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      materiel: null,
      libelle: '',
      listeEtats: traductionLibelleEtat(this.$i18n, ETAT_DISPOSITIF_PUBLICITAIRE),
      constantes: {
        CATALOGUE,
      },
    };
  },
  components: {
    AppBreadcrumb,
    Caracteristiques,
    Produit,
    ProduitsAssocies,
    DisponibiliteParJour,
    Enseignes,
    Audience,
    routerLinkBlank,
    errorMsgComponent,
    pieceJointeButton,
    reglesAchat,
    demandeInterventionType,
  },
  computed: {
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    ...ProduitStore.mapGetters({
      produitEcranNum: 'produit',
    }),
    ...Societe.mapGetters({
      societe: 'societeActive',
    }),
    modulePresseActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePresse.key);
    },
    breadcrumb() {
      const output = [
        {
          title: this.$i18n.t('catalogue.racine'),
          route: this.$PAGE_DEFAULT,
          isActive: false,
        },
        {
          title: this.$i18n.t('catalogue.titleProduit'),
          route: { name: 'l.bodac.catalogue' },
          isActive: false,
        },
        {
          title: this.$i18n.t('catalogue.type.numerique'),
          route: { name: 'm.bodac.catalogue-typeCreation' },
          isActive: false,
        },
        { title: this.getTitle, route: { name: '' }, isActive: true },
      ];
      return output;
    },
    getTitle() {
      return this.productId ? this.$i18n.t('catalogue.editProduct.title',
        { libelle: this.libelle }) : this.$i18n.t('catalogue.newProduct.title');
    },
    productId() {
      return this.$route.params.produitId;
    },
    isSynchro() {
      return this.produit.produitEcranNumerique.materielId !== null;
    },
    tabs() {
      return [
        {
          component: 'produit',
          libelle: 'catalogue.newProduct.tab.product',
          show: true,
          detail: false,
        },
        {
          component: 'caracteristiques',
          libelle: 'catalogue.newProduct.tab.caracteristiques',
          show: true,
          detail: false,
        },
        {
          component: 'produits-associes',
          libelle: 'catalogue.newProduct.tab.products',
          show: true,
          detail: false,
        },
        {
          component: 'disponibilite-par-jour',
          libelle: 'catalogue.newProduct.tab.dispo',
          show: true,
          detail: false,
        },
        {
          component: 'audience',
          libelle: 'catalogue.audience',
          show: true,
          detail: false,
        },
        {
          component: 'enseignes',
          libelle: 'catalogue.marques',
          show: true,
          detail: false,
        },
        {
          component: 'reglesAchat',
          libelle: 'catalogue.newProduct.tab.regleAchat',
          show: this.modulePresseActive,
          detail: !!this.produit.regroupementProduitId,
        },
        {
          component: 'demandeInterventionType',
          libelle: 'catalogue.newProduct.tab.demandeInterventionType',
          show: true,
          detail: false,
        },
      ].filter(t => t.show);
    },
    activeComponent() {
      return this.tabs.find(t => t.component === this.activeTab);
    },
  },

  beforeRouteEnter(to, from, next) {
    let tab = '';
    switch (from.name) {
      case 'm.bodac.catalogue-ajoutProduitAssocie':
        tab = 'produits-associes';
        break;
      default:
        tab = 'produit';
    }
    next(vm => {
      vm.activeTab = tab;
    });
  },

  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.modulePresse.key]);
      if (this.produitEcranNum) {
        this.produit = this.produitEcranNum;
        this.updateProduit(null);
      } else if (!this.productId) {
        await this.setAttachmentContext({ module: 'ProduitEcranNumerique' });
        this.produit = await genererProduitNumerique();
        if (this.societe.produitAssocieLocationEcranNumId) {
          const liaison = await genererLiaisonTarifFromProduitAssocieLoc(
            this.societe.produitAssocieLocationEcranNumId,
          );
          this.produit.liaisonsTarif = [liaison];
        }
        this.setInformationPage(this.$t('pageGescom.produit.creationEcranNumerique'));
      } else if (this.productId) {
        await this.setAttachmentContext({ module: 'ProduitEcranNumerique' });
        const produit = (await get(this.productId)).data.result;
        this.produit = formatProduitAfterGet(produit);
        this.setInformationPage(this.$t('pageGeneral.modification', { item: this.produit.libelle + ' / ' + this.produit.produitEcranNumerique.format + ' / ' + adressFullStringGetter(this.produit.produitEcranNumerique.adresse) }));
        if (this.isSynchro) {
          this.materiel = (await getMaterielPatrimonial(
            this.produit.produitEcranNumerique.materielId,
          )).data.result;
        }
      }
      if (this.productId) await this.setAttachmentElementId({ id: this.productId });
      this.libelle = cloneDeep(this.produit.libelle);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
  methods: {
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
      insertAttachments: 'insert',
      updateAttachments: 'update',
    }),
    ...ProduitStore.mapActions({
      updateProduit: 'updateProduit',
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    async saveProduct() {
      this.champsVide = [];
      this.messagesChampsVide = [];
      this.messages = [];
      const loadingComponent = this.$buefy.loading.open();
      try {
        const produit = formatProduitBeforeSave(this.produit);
        let produitFace = {};
        if (this.$route.params.produitId) {
          produitFace = (await update(produit)).data.result;
          await this.updateAttachments(this.$route.params.id);
          messageSucces(this.$t('catalogue.updateSuccess'));
        } else {
          if (this.isSynchro) {
            produitFace = (await createAvecSynchronisation(produit)).data.result;
          } else {
            produitFace = (await create(produit)).data.result;
          }
          await this.setAttachmentElementId({ id: produitFace.id });
          await this.insertAttachments(produitFace.id);
          messageSucces(this.$t('catalogue.addSuccess'));
        }
        loadingComponent.close();
        this.$router.push({
          name: 'c.bodac.catalogue-ecranNumerique',
          params: { id: produitFace.id },
        });
      } catch (e) {
        if (e.response.data.error) {
          this.error = true;
          this.messages = validationProduit(e.response);
          validationGeneral(
            this.$i18n,
            e.response,
            this.champsVide,
            this.messages,
            this.messagesChampsVide,
            translate,
          );
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    getEtatEcran(codeEtat) {
      const etatFind = this.listeEtats.find((etat) => {
        return etat.value === codeEtat;
      });
      return etatFind ? etatFind.libellei18n : null;
    },
  },
};
</script>
